import { __ } from '@wordpress/i18n';
import {
	TextareaControl,
	ToggleControl,
  Button,
  Notice
} from '@wordpress/components';

import { useDispatch } from '@wordpress/data';
import { InputSwitch } from 'primereact/inputswitch';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import 'primeicons/primeicons.css';

const MessageControl = ( { value, onChange } ) => {
	return (
		<TextareaControl
			label={ __( 'Message', 'demnme-learning' ) }
			value={ value }
			onChange={ onChange }
			__nextHasNoMarginBottom
		/>
	);
};

const DisplayControl = ( { value, onChange, label, className } ) => {
	return (
		<div className={`display-control-wrapper ${className || ''}`}>
			{label && <label className="display-control-label">{label}</label>}
			<span className="p-inputswitch-wrapper">
				<InputSwitch
					checked={value}
					onChange={(e) => onChange(e.value)}
					className="display-control-switch"
					pt={{
						slider: { className: 'p-inputswitch-slider-custom' },
						input: { className: 'p-inputswitch-input-custom' }
					}}
				/>
			</span>
		</div>
	);
};

const ButtonControl = ({ onClick, label, className }) => {
  const { createNotice } = useDispatch('core/notices') || {};

  const handleClick = async () => {
    try {
      await onClick(); // Assuming onClick is a promise
      if (createNotice) {
        createNotice('success', 'Settings saved successfully!', {
          type: 'snackbar',
          isDismissible: true,
        });
      } else {
        console.log('Settings saved successfully!');
      }
    } catch (error) {
      if (createNotice) {
        createNotice('error', error.message || 'An error occurred!', {
          type: 'snackbar',
          isDismissible: true,
        });
      } else {
        console.error('An error occurred:', error);
      }
    }
  };

  return (
    <div>
      <Button onClick={handleClick} variant="primary" className={className}>
        {label}
      </Button>
    </div>
  );
};

export { MessageControl, DisplayControl, ButtonControl };